<template>
  <v-dialog
    :value="status"
    :width="width"
    persistent
    @input="$emit('close')"
  >
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Pesquisar automações
        <v-spacer />
        <v-btn
          text
          x-small
          fab
          @click="$emit('close')"
        >
          <v-icon color="error">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="4"
            sm="6"
          >
            <v-text-field
              v-model="automationId"
              clearable
              label="ID"
              hide-details
              outlined
              dense
              @keypress.enter="filterAutomation"
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
            sm="6"
          >
            <v-text-field
              v-model="automationName"
              clearable
              label="Nome"
              hide-details
              outlined
              dense
              @keypress.enter="filterAutomation"
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
            sm="6"
          >
            <v-autocomplete
              v-model="filterStatus"
              :items="items.status"
              clearable
              dense
              placeholder="Todos"
              label="Status"
              outlined
              hide-details
              item-text="label"
              item-value="value"
              @change="filterAutomation"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="error"
          outlined
          @click="resetFilter"
        >
          Limpar filtro
        </v-btn>

        <v-btn
          color="info"
          @click="filterAutomation"
        >
          Pesquisar
          <v-icon
            right
            dark
          >
            {{ icons.mdiMagnify }}
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiClose, mdiMagnify } from '@mdi/js'

export default {
  name: 'FilterServiceAutomations',

  props: {
    status: {
      default: false,
      type: Boolean,
    },
    width: {
      default: 800,
      type: Number,
    },
  },

  setup() {
    const automationId = ref(null)
    const automationName = ref(null)
    const filterStatus = ref(null)

    const items = {
      status: [
        { label: 'Ativo', value: 1 },
        { label: 'Inativo', value: 0 },
      ],
    }

    return {
      automationId,
      automationName,
      filterStatus,
      items,

      // icons
      icons: {
        mdiClose,
        mdiMagnify,
      },
    }
  },

  methods: {
    resetFilter() {
      this.automationId = null
      this.automationName = null
      this.filterStatus = null

      this.$emit('filter', {})
    },

    filterAutomation() {
      this.$emit('filter', {
        id: this.automationId || null,
        name: this.automationName || null,
        status: this.filterStatus !== null ? this.filterStatus : null,
      })
    },
  },
}
</script>

